import React from "react";
import { Box, Collapse, Stack, Typography, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { Squash as Hamburger } from "hamburger-react";
import SocialIcons from "../UI/IconsComponents/SocialIcons";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import partenopeLogo from "../../assets/Partenope/logo.png";

function MenuCollapse() {
  const [rootExpanded, setRootExpanded] = React.useState(false);
  const isMobile = useMediaQuery("(max-width: 1024px)");

  const { t } = useTranslation(); // Usa il hook useTranslation
  const location = useLocation();
  const isRoomPage = location.pathname.startsWith("/rooms/");
  const navigationLinks = [
    {
      text: t("home"),
      link: "/",
    },
    {
      text: t("immobili"),
      link: "/immobili",
    },
    {
      text: t("Chi siamo"),
      link: "/about",
    },
    {
      text: t("Raggiungici"),
      link: "/raggiungici",
    },
    {
      text: t("Contattaci"),
      link: "/contattaci",
    },
  ];

  return (
    <Box
      sx={{
        pointerEvents: "auto",
        zIndex: 1500,
        backgroundColor: "#fff",
      }}
      onClick={() => setRootExpanded(!rootExpanded)}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: isMobile ? "40%" : "60%",
          margin: "0 auto",
          height: "100%",
          backgroundColor: "#fff",
        }}
      >
        <img
          src={partenopeLogo}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          alt="partenope Logo"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          cursor: "pointer",
          borderTop: "0.2px solid #0C6B8B32",
          backgroundColor: isRoomPage ? "#0c6b8b" : "white",
        }}
      >
        <Typography
          variant={"body2"}
          sx={{
            color: isRoomPage ? "white" : "#0c6b8b",
            fontWeight: 500,
            fontSize: "18px",
            display: "block",
            textTransform: "uppercase",
          }}
        >
          {t("menu")} {/* Traduci il testo del menu */}
        </Typography>
        <Hamburger
          size={16}
          hideOutline={false}
          duration={0.8}
          color={isRoomPage ? "white" : "#0c6b8b"}
          toggled={rootExpanded}
        />
      </Box>

      <Collapse in={rootExpanded}>
        <Stack
          spacing={3}
          width={"100%"}
          alignItems={"center"}
          sx={{
            backgroundColor: "white",
          }}
        >
          {navigationLinks.map((link, index) => (
            <Link
              key={index}
              to={link.link}
              style={{
                textDecoration: "none",
                width: "100%",
                marginTop: 0,
                padding: 4,
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  p: 0,
                  pb: 0.2,
                  marginTop: 0,
                  fontWeight: 500,
                  letterSpacing: 2,
                  color: "#0c6b8b",
                  borderBottom: "0.1px solid #0c6b8b",
                  textTransform: "uppercase",
                  fontFamily: "degular",
                }}
                variant={"body1"}
              >
                {link.text} {/* Traduci il testo del link */}
              </Typography>
            </Link>
          ))}
        </Stack>{" "}
        <Stack
          sx={{ paddingBottom: 3, backgroundColor: "white" }}
          width={"100vw"}
          alignItems={"center"}
        >
          <SocialIcons isRow />
        </Stack>
      </Collapse>
    </Box>
  );
}

export default MenuCollapse;
